import { render } from "./ProfilePage.vue?vue&type=template&id=aac10724"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"

import "./ProfilePage.vue?vue&type=style&index=0&id=aac10724&lang=css"
script.render = render

export default script